export default "__VITE_ASSET__BlRyAGWC__"